export const MOBILEWIDTH = 800;
export const MAXHOURS = 24;
export const MINHOURS = 0;
export const STEPSIZE = 0.5;
export const DEFAULT_COMPANY_NAME = "Offcode";
export const DEFAULT_PROJECT_NAME = "Default Hours";
export const DEFAULT_PROJECT_ID = "93b9dfc8-ce89-4632-8f43-79657a640f25";
export const MAX_PROJECT_NAME_LENGTH = 50;
